/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HoldStatus {
    URN_FLUX_BILLING_HOLD_STATUS_ON_HOLD = 'urn:flux:billing:hold_status:on_hold',
    URN_FLUX_BILLING_HOLD_STATUS_NO = 'urn:flux:billing:hold_status:no',
}
